import { useLocation, useNavigate, useParams } from "react-router-dom"
import { Swiper, SwiperSlide } from "swiper/react"
import type { GalleryContent } from "@/service/api/gallery"
import close from "@/assets/images/icons/close.svg"
import "swiper/css"

const GalleryDetail = () => {
  const { id } = useParams<{ id: string }>()
  const parsedId = id ? Number(id) : 0

  const navigate = useNavigate()
  const location = useLocation()
  const galleryList: GalleryContent[] = location.state?.galleryList

  const initialIndex = galleryList.findIndex((item) => item.id === parsedId)

  return (
    <div className="flex fixed inset-0 justify-center z-100">
      <div className="min-w-[360px] max-w-[768px] w-full min-h-screen bg-black/90">
        <div className="flex justify-between items-center p-4">
          <button onClick={() => navigate(-1)} className="cursor-pointer">
            <img src={close} alt="Close Icons" />
          </button>
        </div>

        <div className="h-[90vh] flex items-center justify-center">
          <Swiper
            className="p-3 w-full h-full"
            initialSlide={initialIndex >= 0 ? initialIndex : 0}
            spaceBetween={50}
            slidesPerView={1}
          >
            {galleryList.map((item: GalleryContent) => (
              <SwiperSlide
                className="flex justify-center items-center"
                key={item.id}
              >
                <div className="flex overflow-hidden justify-center items-center w-full aspect-square bg-black/80">
                  <img
                    src={item.imageUrl}
                    alt={item.title || "Image"}
                    className="object-contain h-full"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export default GalleryDetail
